export default "__VITE_ASSET__DHLHCGH6__"